<template>
    <div>
        <h3>Comptabilité</h3>
        <b-form-checkbox
            v-model="ten"
            name="check-button"
            switch
            @change="toggle('ten')"
        >
            Tenue
        </b-form-checkbox>
        <b-form-checkbox
            v-model="sit"
            name="check-button"
            switch
            @change="toggle('sit')"
        >
            Situation
        </b-form-checkbox>
        <b-form-checkbox
            v-model="bil"
            name="check-button"
            switch
            @change="toggle('bil')"
        >
            Bilan
        </b-form-checkbox>
        <hr />
        <h3>Taxes</h3>
    </div>
</template>

<script>
export default {
    name: 'ClientMissionsHandler',

    created() {},
    methods: {
        toggle(mission) {},
    },
}
</script>

<style scoped></style>
